<script setup lang="ts">
import { useLogoutConfirm } from '../composables/useLogoutConfirm'
import AppButtonIcon from '../../buttons/AppButtonIcon.vue'
import AppDialog from '../../dialogs/AppDialog.vue'

const {
  acceptLogout,
  closeLogoutConfirm,
  isLogoutConfirmVisible,
  isLogoutLoading,
  logoutAcceptLabel,
  logoutCancelLabel,
  logoutConfirmMessage,
  logoutConfirmTitle,
  logoutChatOutcome,
  logoutChatOutcomeMessage,
  logoutChatsCheckingLabel,
} = useLogoutConfirm()
</script>

<template>
  <AppDialog
    :model-value="isLogoutConfirmVisible"
    modal
    :closable="!isLogoutLoading"
    custom-class="backdrop-blur-xl!"
    :dismissable-mask="!isLogoutLoading"
    :draggable="false"
    :header="logoutConfirmTitle"
    width="min(28rem, calc(100vw - 2rem))"
    @update:model-value="(value) => (!value ? closeLogoutConfirm() : undefined)"
  >
    <div class="flex items-start gap-3">
      <i class="pi pi-exclamation-triangle mt-1 text-lg text-orange-500" />
      <div>
        <p class="m-0 text-sm leading-6 text-gray-700 dark:text-gray-200">
          {{ logoutConfirmMessage }}
        </p>
        <div
          v-if="logoutChatOutcome === 'loading'"
          class="mt-2 flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400"
        >
          <i class="pi pi-spin pi-spinner" />
          <span>{{ logoutChatsCheckingLabel }}</span>
        </div>
        <p
          v-else-if="logoutChatOutcomeMessage"
          class="m-0 mt-2 text-xs text-gray-500 dark:text-gray-400"
        >
          {{ logoutChatOutcomeMessage }}
        </p>
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end gap-2 w-full">
        <AppButtonIcon
          :label="logoutCancelLabel"
          severity="secondary"
          outlined
          class="w-full"
          :block="false"
          :disabled="isLogoutLoading"
          @click="closeLogoutConfirm"
        />
        <AppButtonIcon
          type="button"
          severity="primary"
          :label="logoutAcceptLabel"
          :loading="isLogoutLoading"
          :disabled="isLogoutLoading || logoutChatOutcome === 'loading'"
          @click="acceptLogout"
        />
      </div>
    </template>
  </AppDialog>
</template>
